<template>

          <!----------- downloads ---------------------------------->
          <div class="column is-12">
            <div class="box">
              <div class="columns">
                <div class="column is-12">
                  <strong>{{ elLabel }}</strong>

                  <a class="icon is-info is-large is-pulled-right" @click="$emit('showImageSelector', 'downloads')">
                    <i class="fa fa-plus-circle fa-2x"></i>
                  </a>

                </div>
              </div>

              <draggable v-model="n" :options="{draggable:'.column', handle:'.my-handle'}" class="columns is-multiline">
                <div class="column is-3" v-for="(i, index) in n" :key="index">

                  <div class="card card-equal-height">
                  <header class="card-header">
                <a class="is-pulled-right icon my-handle">
                  <i class="fa fa-arrows"></i>
                </a>
            </header>
                    <div class="card-image" v-if="isImage(i.url)">
                      <figure class="image">
                        <img :src="assetsBaseUrl + i.url">
                      </figure>
                    </div>
                    <div class="card-image has-text-centered" v-else>
                      <figure class="image">
                        <img src="../../../assets/file.png">
                      </figure><br>{{ i.url }}
                    </div>
                    <div class="card-content">
                      <div class="content">


                        <div class="control has-icons-right"><input
                          class="input"
                          v-model="i.caption"
                          maxlength="30"
                          :name="'linkcaption' + index" 
                          :class="{'input': true, 'is-danger': errors.has('linkcaption' + index) }" 
                          v-validate="'required'"
                          placeholder="Download-Button Text">
                          <span class="icon is-right" v-show="errors.has('linkcaption' + index)"><i class="fa fa-warning"></i></span><span v-show="errors.has('linkcaption' + index)" class="help is-danger">Benötigtes Feld</span></div>


                        </div>
                      </div>
                      <footer class="card-footer">
                        <a class="card-footer-item" @click="$emit('downloadWasDeleted', index)">Löschen</a>
                      </footer>
                    </div>

                  </div>
                </draggable>
              </div>
            </div>

</template>

<script>
import draggable from 'vuedraggable'
export default {
  inject: ['$validator'],
  props: ['data', 'isImage', 'elLabel'],
  data () {
    return {
    }
  },
  methods: {
  },
  components: {
    draggable
  },
  computed: {
    n: {
      get () {
        return this.data
      },
      set (value) {
        this.$emit('wasSorted', value)
      }
    },
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  }
}
</script>

<style scoped>
.card-content {padding:0;}
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Downloads.vue